import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";
import { Reveal } from "../components/motion/Reveal";
import { RevealImage } from "../components/motion/RevealImage";

export function NotFound() {
  return (
    <>
      <SEO title="Page Not Found | The Deposit Seed House" description="The requested page could not be found." />
      <section className="page-hero page-hero--not-found">
        <Reveal className="not-found-hero__content">
          <p className="eyebrow">404</p>
          <h1>Page not found</h1>
          <p>The page may have moved during the rebuild.</p>
          <div className="page-hero__actions">
            <Link className="button button--primary" to="/apartments">
              View apartments
            </Link>
            <Link className="button button--light" to="/contact">
              Contact owner
            </Link>
          </div>
        </Reveal>
        <div className="not-found-hero__visual" aria-hidden="true">
          <RevealImage src="/assets/site/only-for-the-hero.webp" alt="" />
        </div>
      </section>
    </>
  );
}
